import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';
import type { UAPPlacementComponentProps } from '../../@types';

import {
  getResponsiveOutlookMobilePlacementStyles,
  getResponsiveOutlookWebPlacementStyles,
} from '../../styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';

import {
  BusinessNameWithAdsLabel,
  PlacementHeadline,
  PlacementDescription,
} from '../../shared-components';

export const OutlookPlacementBase = ({
  // UAPVMSingleImagePlacement
  placementData,

  businessName,
  shortHeadline,
  isMultiLineShortHeadline,
  finalUrl,
  displayUrl,
  description,
  isMultiLineDescription,
  showLogo,
  logo,

  // may need to set window._TL_ in other platforms
  i18n,

  classes,
  customClassName,
}: UAPPlacementComponentProps) => (
  <div className={classnames(classes.placementCard, 'ad-placement-card-preview', customClassName)}>
    <a
      className="placement-card-content"
      target="_blank"
      rel="noopener noreferrer"
      href={finalUrl || displayUrl}
    >      {showLogo && logo &&
      <div className={classnames(classes.placementLogoContainer, 'logo-container')}>
        <CroppedImageView
          resizeImageHeight={(placementData && placementData.placementMeta && placementData.placementMeta.logoHeight) || 24}
          src={logo.Src}
          originalWidth={logo.Width}
          originalHeight={logo.Height}
          SourceX={logo.CropSettings.SourceX}
          SourceY={logo.CropSettings.SourceY}
          SourceWidth={logo.CropSettings.SourceWidth}
          SourceHeight={logo.CropSettings.SourceHeight}
          aspectRatio={1}
        />
      </div>
    }
      <div className={classnames(classes.placementTextContainer, 'text-container')}>
        <BusinessNameWithAdsLabel
          showAdsLabel
          businessName={businessName}
          i18n={i18n}
          rootClassName={classnames(classes.placementBusinessNameWithAdsLabel, 'business-name-with-ads')}
        />
        <PlacementHeadline

          headlineText={shortHeadline}
          isMultiLine={isMultiLineShortHeadline}
          placementHeadlineClassName={classnames(classes.placementShortHeadline, 'short-headline')}
        />
        <PlacementDescription

          description={description}
          isMultiLine={isMultiLineDescription}
          placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
        />
      </div>
    </a>
  </div>
);

OutlookPlacementBase.propTypes = {
  placementData: PropTypes.shape({}).isRequired, // UAPVMSingleImagePlacement
  businessName: PropTypes.string,
  shortHeadline: PropTypes.string,
  isMultiLineShortHeadline: PropTypes.bool,
  finalUrl: PropTypes.string,
  displayUrl: PropTypes.string,

  description: PropTypes.string,
  isMultiLineDescription: PropTypes.bool,

  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    placementCard: PropTypes.string,
    placementTextContainer: PropTypes.string,
    placementBusinessNameWithAdsLabel: PropTypes.string,
    placementShortHeadline: PropTypes.string,
    placementDescription: PropTypes.string,
  }).isRequired,
  customClassName: PropTypes.string,
  showLogo: PropTypes.bool,
  logo: PropTypes.shape({
    Src: PropTypes.string,
    Width: PropTypes.number,
    Height: PropTypes.number,
    CropSettings: PropTypes.shape({
      SourceX: PropTypes.number,
      SourceY: PropTypes.number,
      SourceWidth: PropTypes.number,
      SourceHeight: PropTypes.number,
    }),
  }),
};

OutlookPlacementBase.defaultProps = {
  businessName: undefined,
  shortHeadline: undefined,
  isMultiLineShortHeadline: false,
  finalUrl: undefined,
  displayUrl: undefined,
  description: undefined,
  isMultiLineDescription: false,
  customClassName: undefined,
  showLogo: false,
  logo: undefined,
};

export const ResponsiveAdPlacementOutlookMobile = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => (<OutlookPlacementBase
    {...props}
    // isMultiLineShortHeadline
    // isMultiLineDescription
    isMultiLineShortHeadline={false}
    isMultiLineDescription={false}
    showLogo
  />),
  getResponsiveOutlookMobilePlacementStyles,
  { componentName: 'AdPlacementOutlookMobile' }
);

export const ResponsiveAdPlacementOutlookWeb = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => (<div className={props.classes?.outlookWebCardRoot}>
    <OutlookPlacementBase
      {...props}
      isMultiLineShortHeadline={false}
      isMultiLineDescription={false}
      showLogo
    />
                                          </div>),
  getResponsiveOutlookWebPlacementStyles,
  { componentName: 'AdPlacementOutlookWeb' }
);
